import { useSelector } from "react-redux";
import { getStorageInboundDetail } from "../store";
import { useAppointmentDetailsBase } from "inbounds/steps/ship/view/cards/confirmation/sharedComponents/useAppointmentDetails";
import log, { logError, logStart } from "Logger";

export const useStorageAppointmentDetails = () => {
  const storageDetail = useSelector(getStorageInboundDetail);
  const shipmentIdString = storageDetail?.storageInboundOrder?.shipmentId ?? null;
  const sellerId = storageDetail?.storageInboundOrder?.sellerId ?? null;

  // Convert shipmentId to a number if it's a string and not null
  const shipmentId = shipmentIdString ? Number(shipmentIdString) : null;

  // Add logging wrapper
  if (!shipmentId || !sellerId) {
    const ctx = logStart({ fn: "useStorageAppointmentDetails", shipmentId, sellerId });
    log.info(ctx, "Missing required IDs, returning default state");
  }

  const appointmentDetails = useAppointmentDetailsBase(shipmentId, sellerId);

  if (appointmentDetails.error) {
    const ctx = logStart({ fn: "useStorageAppointmentDetails", shipmentId, sellerId });
    logError(ctx, appointmentDetails.error, "Failed to fetch appointment details");
  }

  // Return the same interface as before
  return {
    ...appointmentDetails,
    // Type cast bolId and containerId if needed
    bolId: appointmentDetails.bolId as string | null,
    containerId: appointmentDetails.containerId as string | null,
  };
};
